var TorsoView = require('backbone-torso/modules/View');
var authenticationFooter = require('./authenticationFooter.hbs');
var applicationUtils = require('./../applicationUtils');

/**
 * View to display the authentication footer
 *
 * @class AuthenticationFooterView
 * @constructor
 * @param options {Object} Options to configure this view.
 *   @param [options.isPatient=false] {Boolean} whether this is a patient-facing view or a staff-facing view.
 */
module.exports = TorsoView.extend({
  tagName: 'footer',
  className: 'brec-authentication__footer',
  moduleNamespace: 'authPerspective',
  template: authenticationFooter,
  prepareFields: [{
    name: 'isPatient',
    value: '_isPatient'
  }, {
    name: 'currentApplication',
    value: applicationUtils.currentApplication
  }, {
    name: 'APPLICATIONS',
    value: applicationUtils.APPLICATIONS
  }],

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view.
   *   @param [options.isPatient=false] {Boolean} whether this is a patient-facing view or a staff-facing view.
   */
  initialize: function(options) {
    options = options || {};
    this._isPatient = options.isPatient;
  }
});
